module.exports = __webpack_public_path__ + "static/media/segBio.9463c955.png";